import { render, staticRenderFns } from "./MarketingLandingPage.vue?vue&type=template&id=428b8e94&"
import script from "./MarketingLandingPage.vue?vue&type=script&lang=js&"
export * from "./MarketingLandingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports